import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { ControllerBase } from "controllerBase";
import global from 'globalMU'

declare var window:any

const ResumoOrcamentoController = ControllerBase.extend({
    name: "ResumoOrcamentoController",

    framework: "knockout",

    ajax: function () {
        return  {
            url: "/Orcamento/_Resumo",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            }
        };
    },

    events: { // FNX-4901
        'select2:select select[name="TipoOperacao"]': "definirDadosAlterados",
        'blur input[id="Resumo_GrupoOpcaoOrcamento_ApenasOrcamento"]': "definirDadosAlterados",
        'blur input[id="Resumo_GrupoOpcaoOrcamento_EnviarSupervisao"]': "definirDadosAlterados",
        'blur input[id="Resumo_GrupoOpcaoOrcamento_ApenasConfirmado"]': "definirDadosAlterados",
        'blur input[id="Resumo_GrupoOpcaoOrcamento_OrcamentoConfirmado"]': "definirDadosAlterados",
        'blur input[name="UsarObservacaoTextoLivreNF"]': "definirDadosAlterados",
        'blur #Resumo_DataValidadeInput': "definirDadosAlterados",
        'blur select[name="Finalidade"]': "definirDadosAlterados",

        'change input[name="PedidoCompraCliente"]': "definirDadosAlterados",
        'change input[name="ObservacaoNF"]': "definirDadosAlterados",
        'change textarea[name="ObservacaoOrcamento"]': "definirDadosAlterados",
    },

    definirDadosAlterados: function (e) {
        if (e) e.preventDefault();
        if (e.target.name === "ObservacaoOrcamento") // FNX-4901 -- nao esta alterando o model por causa do "change" do events
            this.model.ObservacaoOrcamento(e.target.value)
        else if (e.target.name === "PedidoCompraCliente")
            this.model.PedidoCompraCliente(e.target.value)
        else if (e.target.name === "ObservacaoNF") { // FNX-4901
            this.model.ObservacaoNF(e.target.value)
        }

        else if (e.target.name === "Finalidade")
            this.model.Finalidade(e.target.value)

        if (this.orcamento)
            this.orcamento.DadosAlterados = true; // FNX-4901
    },

    aposBinding: function () {
        this.parent.ajustarOpcaoDoOrcamento(this.model, this.orcamento, 'Resumo_');

        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });

        if (this.orcamento.get("Situacao") === null) {
            $("html, body").animate({ scrollTop: $('#Resumo_OpcaoOrcamento').offset().top }, 500);
            $('#Resumo_OpcaoOrcamento').focus();
        } else {
            //$("html, body").animate({ scrollTop: $("html, body").offset().top }, 500);
            $('#salvar-orcamento').focus();
        }
    },

    tipoOperacaoSelect2Options: {},

    renderizado: function () {
        
    },


    formConfig: {
        selector: "#form-orcamento",
        submit: {
            selector: "#salvar-orcamento",
            loadingText: "Aguarde...",
            callback: "salvar",
            type: "model",
            modelType: "js"
        },
        rules: {
            'TipoOperacao': {
                required: function() {
                    return this.model.TipoOperacaoObrigatorio();
                }
            },
            'Finalidade': {
                required: function() {
                    return this.orcamento.get("RequisitarFinalidadeVenda");
                }
            },
            'DataValidade': {
                validateDate: true
            }
        },
        messages: {
            'TipoOperacao': {
                required: "O campo \"Tipo de Operação\" é obrigatório."
            },
            'Finalidade': {
                required: "O campo \"Finalidade\" é obrigatório."
            },
            'DataValidade': {
                validateDate: "O campo \"Data Validade\" é inválido."
            }
        },
        ignore: []

    },
    definirPedidoCompra: function(e, f) {
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirPedidoCompra",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                pedidoCompra: $("#PedidoCompraCliente").val()
            },
            success: function(data) {

            }
        });
    },
    salvar: function () {
        
        var situacao = null;
        var situacaoRadio = $('input[name=Resumo_GrupoOpcaoOrcamento]:checked').val() as string
        if (situacaoRadio === undefined) {
            global.showErrorMessage("O campo \"Opções de Orçamento\" é obrigatório.");
            $("html, body").animate({ scrollTop: $('#Resumo_OpcaoOrcamento').offset().top }, 500);
            $('#Resumo_OpcaoOrcamento').focus();
            return;
        }

        situacao = parseInt(situacaoRadio);

        var finalidade = this.orcamento.get("FinalidadeVenda");
        var dataValidade = this.orcamento.get("DataValidade");
        var pedidoCompraCliente = this.orcamento.get("PedidoCompraCliente");
        var tipoOperacao = this.orcamento.get("TipoOperacao");
        var observacaoNF = this.orcamento.get("ObservacaoNF");
        var observacaoOrcamento = this.orcamento.get("ObservacaoOrcamento");
        var usarObservacaoTextoLivreNF = this.orcamento.get("UsarObservacaoTextoLivreNF");
        var valorMercadoriasAnterior = this.orcamento.get("ValorTotalMercadorias");
        var aplicaDescontoCashbackAnterior = this.orcamento.get("AplicaDescontoCashback");

        this.orcamento.set("Situacao", situacao);
        this.orcamento.set("FinalidadeVenda", this.model.FinalidadeVenda());
        this.orcamento.set("DataValidade", this.model.DataValidade());
        this.orcamento.set("PedidoCompraCliente", this.model.PedidoCompraCliente());
        this.orcamento.set("TipoOperacao", this.model.TipoOperacao());
        this.orcamento.set("ObservacaoNF", this.model.ObservacaoNF());
        this.orcamento.set("ObservacaoOrcamento", this.model.ObservacaoOrcamento());
        this.orcamento.set("UsarObservacaoTextoLivreNF", this.model.UsarObservacaoTextoLivreNF());

        store.dispatch(sobrescreverInformacoesAction({
            Situacao: situacao,
            FinalidadeVenda: this.model.FinalidadeVenda(),
            DataValidade: this.model.DataValidade(),
            PedidoCompraCliente: this.model.PedidoCompraCliente(),
            TipoOperacao: this.model.TipoOperacao(),
            ObservacaoNF: this.model.ObservacaoNF(),
            ObservacaoOrcamento: this.model.ObservacaoOrcamento(),
            UsarObservacaoTextoLivreNF: this.model.UsarObservacaoTextoLivreNF(),
        }))



        var self = this;

        global.ajax({
            url: "/Orcamento/AtualizarDadosOrcamento",
            type: "post",
            contentType: "application/json",
            cache: false,
            data: global.toJSONString({
                orcamento: this.orcamento.toJSON()
            }),
            success: function(data) {
                if (data) {

                    situacao = data.Situacao;
                    finalidade = data.FinalidadeVenda;
                    dataValidade = data.DataValidade;
                    pedidoCompraCliente = data.PedidoCompraCliente;
                    tipoOperacao = data.TipoOperacao;
                    observacaoNF = data.ObservacaoNF;
                    observacaoOrcamento = data.ObservacaoOrcamento;
                    usarObservacaoTextoLivreNF = data.UsarObservacaoTextoLivreNF;

                    if (!data.HasErrors) {
                        global.showSuccessMessage("Dados do orçamento atualizados com sucesso.");
                    }
                }

                self.model.Situacao(situacao);
                self.model.FinalidadeVenda(finalidade);
                self.model.DataValidade(dataValidade);
                self.model.PedidoCompraCliente(pedidoCompraCliente);
                self.model.TipoOperacao(tipoOperacao);
                self.model.ObservacaoNF(observacaoNF);
                self.model.ObservacaoOrcamento(observacaoOrcamento);
                self.model.UsarObservacaoTextoLivreNF(usarObservacaoTextoLivreNF);

                self.orcamento.set("Situacao", situacao);
                self.orcamento.set("FinalidadeVenda", finalidade);
                self.orcamento.set("DataValidade", dataValidade);
                self.orcamento.set("PedidoCompraCliente", pedidoCompraCliente);
                self.orcamento.set("ObservacaoNF", observacaoNF);
                self.orcamento.set("TipoOperacao", tipoOperacao);
                self.orcamento.set("CalcularFreteAutomaticamente", false);

                store.dispatch(sobrescreverInformacoesAction({
                    Situacao: situacao,
                    FinalidadeVenda: finalidade,
                    DataValidade: dataValidade,
                    PedidoCompraCliente: pedidoCompraCliente,
                    ObservacaoNF: observacaoNF,
                    TipoOperacao: tipoOperacao,
                    CalcularFreteAutomaticamente: false
                }))



                self.orcamento.atualizar(data);

                $('html, body').animate({ scrollTop: $('html, body').offset().top }, 500);

                if (data.ValorTotalMercadorias && valorMercadoriasAnterior !== data.ValorTotalMercadorias) { // FNX-1613 -- FNX-63
                    if (!aplicaDescontoCashbackAnterior && aplicaDescontoCashbackAnterior !== data.AplicaDescontoCashback && data.Situacao == 6) // Situacao == 6 ->SoOrcando
                    { // 438892
                        global.showInfoMessage("Cashback foi removido</br></br>Valor total das mercadorias foi alterado!");
                    }
                    else if (!aplicaDescontoCashbackAnterior && aplicaDescontoCashbackAnterior !== data.AplicaDescontoCashback) { // 438892
                        global.showInfoMessage("Saldo do cashback do cliente está zerado.</br>Cashback foi removido</br>Favor analisar os descontos!");
                    }
                    else {
                        global.showInfoMessage("Valor total das mercadorias foi alterado!");// FNX-1613 -- FNX-63
                    }
                    valorMercadoriasAnterior = data.ValorTotalMercadoria
                    aplicaDescontoCashbackAnterior = data.AplicaDescontoCashback
                    $("html, body").animate({ scrollTop: $("html, body").offset().top }, 500);
                }

                if (data && !data.HasError && data.VendaComAutorizado) {
                    /*
                    var autorizadoOrcamentoController = new AutorizadoOrcamentoController({
                        orcamento: self.orcamento,
                        finalizarCallback: function() {
                            $("#modalVendaAutorizado").modal("hide");
                        }
                    });
                    autorizadoOrcamentoController.render("#autorizado-region");
                    $("#modalVendaAutorizado").modal();
                    */
                    global.showInfoMessage("Cliente autorizado não informado.<br>Informe a senha do autorizado para continuar!");
                    setTimeout(function () {
                        $('#detalhe-resumo-orcamento-region').hide();
                        self.parent.renderizarViewAutorizadoOrcamento();
                    }, 3000);
                }
                if (self.orcamento)
                    self.orcamento.DadosAlterados = false; // FNX-4901
                
            }
        });
    }
});

window.ResumoOrcamentoController = ResumoOrcamentoController

export {
    ResumoOrcamentoController
}
